import axios from 'axios'

import type { ReportData } from 'common'
import { getToken } from '@/api/coreclient'

export default {
  async create(body: Omit<ReportData, 'token'>) {
    const token = await getToken()

    return axios.post(
      import.meta.env.VITE_REPORT_SERVER_ENDPOINT,
      { ...body, token },
      {
        responseType: 'blob'
      }
    )
  }
}
